import React, { Component } from 'react'
import Tooltip from '@material-ui/core/Tooltip'

export default class IAction extends Component {
	getNotifs = () => this.notifs ? this.notifs() : null

	getDropDown = () => this.dropdown ? this.dropdown() : null

	getComponent = () => this.component ? this.component() : null

	render() {
		const content = (() => {
			if (this.getComponent()) {
				return this.getComponent()
			}
			const dropdown = this.getDropDown()
			const classes = `right waves-effect nav-actions blue-arrow ${ dropdown ? 'dropdown-button' : '' }`
			return (
				<div className='action-wrapper'>
					<Tooltip title={ this.title() } aria-label={ this.title() }>
						<a className={ classes } onClick={ this.fn() }>
							<i className='material-icons left no-margin font-size-30'>{ this.icon() }</i>
							{ this.getNotifs() }
						</a>
					</Tooltip>

					{ dropdown }
				</div>
			)
		})()
		return (
			<div>
				{ content }
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/actions/IAction.js